import React from 'react';
import { FleetUser } from '../pages/LoginPage';

export type FleetView =
  | 'instanzen'
  | 'detail'
  | 'operatoren'
  | 'rollout'
  | 'backups'
  | 'system'
  | 'einstellungen'
  | 'provisionieren';

interface TopStripProps {
  currentView: FleetView;
  user: FleetUser;
  onNavigate: (view: FleetView) => void;
  onLogout: () => void;
}

const TopStrip: React.FC<TopStripProps> = ({ currentView, user, onNavigate, onLogout }) => {
  // Die Detailseite gehoert zur Instanzen-Rubrik — sonst wuerde die Navigation
  // beim Oeffnen einer Instanz ihre Markierung verlieren.
  const rubrik = currentView === 'detail' ? 'instanzen' : currentView;

  return (
    <header className="k-strip">
      <div className="k-strip__left">
        <span className="k-strip__dot"></span>
        <span className="k-strip__brand">Fleet</span>
      </div>

      <nav className="k-strip__nav">
        <button
          className={'k-strip__navbtn' + (rubrik === 'instanzen' ? ' is-active' : '')}
          onClick={() => onNavigate('instanzen')}
        >
          Instanzen
        </button>
        <button
          className={'k-strip__navbtn' + (rubrik === 'operatoren' ? ' is-active' : '')}
          onClick={() => onNavigate('operatoren')}
        >
          Operatoren
        </button>
        <button
          className={'k-strip__navbtn' + (rubrik === 'rollout' ? ' is-active' : '')}
          onClick={() => onNavigate('rollout')}
        >
          Rollout
        </button>
        <button
          className={'k-strip__navbtn' + (rubrik === 'provisionieren' ? ' is-active' : '')}
          onClick={() => onNavigate('provisionieren')}
        >
          Provisionieren
        </button>
        <button
          className={'k-strip__navbtn' + (rubrik === 'system' ? ' is-active' : '')}
          onClick={() => onNavigate('system')}
        >
          System
        </button>
        <button
          className={'k-strip__navbtn' + (rubrik === 'einstellungen' ? ' is-active' : '')}
          onClick={() => onNavigate('einstellungen')}
        >
          Einstellungen
        </button>
      </nav>

      <div className="k-strip__right">
        <span className="k-strip__user" title={user.email}>
          {user.name} <span className="k-strip__sep">/</span> {user.rolle}
        </span>
        <button className="k-strip__btn" onClick={onLogout}>
          Abmelden
        </button>
      </div>
    </header>
  );
};

export default TopStrip;
